import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/web/login',
    method: 'post',
    params: data
  })
}

export function getInfo(token) {
  return request({
    url: '/web/service?method=tCoreUser_getUserInfo',
    method: 'post',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/web/logout',
    method: 'post'
  })
}

// 获取菜单
export function menuList() {
  return request({
    url: '/web/service?method=tCoreMenu_platformList',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js